// extracted by mini-css-extract-plugin
module.exports = {"logo":"Signup_logo__1-wNa","topWrap":"Signup_topWrap__9DZjs","menuWrap":"Signup_menuWrap__-_o_d","link":"Signup_link__3MJff","trial":"Signup_trial__2nrZU"};